/* eslint-disable react-refresh/only-export-components */
import { Button } from '@repo/ui/src/components/ui/button';

/** Single source of truth for page count — callers need it to format their
 * own summary string, and the component needs it for the render-nothing
 * check, so it's shared rather than computed twice. */
export function pageCount(total: number, pageSize: number): number {
  return Math.ceil(total / pageSize);
}

/** Shared pager for server-paginated list pages. Namespace-agnostic: callers
 * pass already-translated labels/summary from their own i18n namespace. */
export function PaginationFooter({
  page,
  pageSize,
  total,
  onPageChange,
  summary,
  prevLabel,
  nextLabel,
}: {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  summary: string;
  prevLabel: string;
  nextLabel: string;
}) {
  const pages = pageCount(total, pageSize);
  if (pages <= 1) return null;

  return (
    <div className="mt-4 flex items-center justify-between gap-3">
      <span className="text-sm text-surface-500">{summary}</span>
      <div className="flex gap-2">
        <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
          {prevLabel}
        </Button>
        <Button variant="outline" size="sm" disabled={page >= pages} onClick={() => onPageChange(page + 1)}>
          {nextLabel}
        </Button>
      </div>
    </div>
  );
}
